module.exports = __webpack_public_path__ + "img/sficon.b64ac603.png";